export const state = () => ({
  stepAbTestProtection: false
})

export const mutations = {
  SET_STEP_AB_TEST_PROTECTION(state, value) {
    state.stepAbTestProtection = value
  }
}

export const actions = {
  setStepAbTestProtection({ commit }, value) {
    commit('SET_STEP_AB_TEST_PROTECTION', value)
  }
}

export const getters = {
  stepAbTestProtection: state => state.stepAbTestProtection
}
